export class PSTasacionModel {
  id: number = 0;
  idps: any = null;
  tasacionId: number | null = null;
}

